/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_Parq_ShortInputs */

const en_us2_intake_why_parq_short = /** @type {(inputs: Intake_Why_Parq_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Says when to see a doctor first`)
};

const pt_br2_intake_why_parq_short = /** @type {(inputs: Intake_Why_Parq_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diz quando ver um médico antes`)
};

const es_419_intake_why_parq_short = /** @type {(inputs: Intake_Why_Parq_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dice cuándo ver antes a un médico`)
};

const pt_pt2_intake_why_parq_short = /** @type {(inputs: Intake_Why_Parq_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diz quando ir primeiro ao médico`)
};

const fr_fr2_intake_why_parq_short = /** @type {(inputs: Intake_Why_Parq_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit quand voir d'abord un médecin`)
};

const de_de2_intake_why_parq_short = /** @type {(inputs: Intake_Why_Parq_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sagt, wann du erst zum Arzt solltest`)
};

const it_it2_intake_why_parq_short = /** @type {(inputs: Intake_Why_Parq_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dice quando sentire prima un medico`)
};

/**
* | output |
* | --- |
* | "Says when to see a doctor first" |
*
* @param {Intake_Why_Parq_ShortInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_parq_short = /** @type {((inputs?: Intake_Why_Parq_ShortInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_Parq_ShortInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_parq_short(inputs)
	if (locale === "es-419") return es_419_intake_why_parq_short(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_parq_short(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_parq_short(inputs)
	if (locale === "de-DE") return de_de2_intake_why_parq_short(inputs)
	if (locale === "it-IT") return it_it2_intake_why_parq_short(inputs)
	return en_us2_intake_why_parq_short(inputs)
});
export { intake_why_parq_short as "intake.why.parq.short" }